import React, {useEffect, useState} from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { DatePicker, Spin, Table, Typography} from "antd";
// import { openNotificationWithIcon } from "../../Function";
import moment from "moment";
// import { useSelector } from "react-redux";
// import { CheckCircleOutlined, CloseOutlined} from "@ant-design/icons";
import { GetNgayNghiApi } from "../../../api/getKhaiBao";
const { Link } = Typography;

export const TongHopNgayNghi =()=>{
    const defaultPageSize = 12;
    const [pager, setPager] = useState({pageSize:defaultPageSize});
    const [data, setData] = useState([]);
    // const [dataDetailMonth, setDataDetailMonth] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [currentSelectedDate, setCurrentSelectedDate] = useState(moment(new Date()));

    // const userInfo = useSelector((state)=>state.getUserInfo.userInfo);

    const fetchData = (params = {})=>{
        GetNgayNghiApi({nam: params.nam})
        .then(res=>{
            // console.log(res.data);
            setData(res.data);
            setLoading(false);
        })
    };

    useEffect(()=>{
        fetchData({nam: moment(currentSelectedDate).year()});
    },[]);


    const columns = [
        {
            title: "STT",
            dataIndex: "index",
            key: "index",
            align:'center',
            render: (value, item, index) => ((pager.current || 1) - 1) * pager.pageSize + index + 1,
            sortDirections: ['descend', 'ascend', 'descend'],
        },
        {
            title: "Tháng",
            dataIndex: "thangNam",
            key: "thangNam",
            filterKey: 'thangNam',
            align:'center',
            type: 'text',
            canSearch: true,
            render: (value, item, index) => <>{moment(value,"YYYY-MM-DD").format("MM")}</> ,
        },
        {
            title: "Thứ 7",
            dataIndex: "countThu7",
            key: "countThu7",
            filterKey: 'countThu7',
            align:'center',
            type: 'text',
            canSearch: true
        },
        {
            title: "Chủ nhật",
            dataIndex: "countChunhat",
            key: "countChunhat",
            filterKey: 'countChunhat',
            align:'center',
            type: 'text',
            canSearch: true
        },
        {
            title: "Lễ/Tết",
            dataIndex: "countLetet",
            key: "countLetet",
            filterKey: 'countLetet',
            align:'center',
            type: 'text',
            canSearch: true
        },
        {
            title: "Tổng buổi",
            dataIndex: "tongBuoi",
            key: "tongBuoi",
            filterKey: 'tongBuoi',
            align:'center',
            type: 'text',
            canSearch: true
        },
        {
            title: "Tổng ngày",
            dataIndex: "tongNgay",
            key: "tongNgay",
            filterKey: 'tongNgay',
            align:'center',
            type: 'text',
            canSearch: true
        },
        {
            title: "Ghi chú",
            dataIndex: "ghichu",
            key: "ghichu",
            align:'center',
            filterKey: 'ghichu',
            type: 'text',
            width:'25%',
            ellipsis: true,
            canSearch: true
        },
    ]

    const onChangeYear =(date)=>{
        // setIsCreate(false)
        setCurrentSelectedDate(date);
        fetchData({nam: moment(date).year()});
        // const lsDateTemp = getDateRange(date);
        // setLsDate(lsDateTemp);
    };

    const onQuickChangeYear=(type)=>{
        let yearChange;
        if (type === 'previous'){
            yearChange = moment(currentSelectedDate).subtract(1, 'year');
        } else {
            yearChange = moment(currentSelectedDate).add(1, 'year');
        }
        setCurrentSelectedDate(yearChange);
        fetchData({nam: yearChange.year()});
    }

    const handleChange =(pagination)=>{
        const currentPager = {...pager};
        currentPager.current = pagination.current;
        currentPager.pageSize = pagination.pageSize;
        setPager({...currentPager});
        fetchData({
            status:currentPager.status,
            page_size:pagination.pageSize,
            page:pagination.current,search,
            nam: moment(currentSelectedDate).year()
        })
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Tổng hợp ngày nghỉ</h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link href="#">Nhân sự</Link></li>
                                <li className="breadcrumb-item"><Link href="#">Khai báo</Link></li>
                                <li className="breadcrumb-item active">Tổng hợp ngày nghỉ</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className={'col-12 mb-2 d-sm-flex align-items-center justify-content-between'}>
                    <div className={'col'}>
                        <Button type="primary" className={'m-2 styleNtn_1'} onClick={()=>onQuickChangeYear('previous')} title="Năm trước">
                            <i className={'fa fa-arrow-left'}></i>
                        </Button>
                        <Button type="primary" className={'m-2 styleNtn_1'} onClick={()=>onQuickChangeYear('next')} title="Năm sau">
                            <i className={'fa fa-arrow-right'}></i>
                        </Button>
                        <DatePicker
                            style={{borderRadius:10}}
                            className={'m-2'}
                            onChange={onChangeYear}
                            value={currentSelectedDate}
                            format={'YYYY'}
                            allowClear={false}
                            picker="year"
                        />

                        {/* {userInfo.user_permissions &&userInfo.user_permissions.includes('is_personal_timesheet') &&
                        <Button ghost type='success' className={'m-2'} onClick={()=>openNotificationWithIcon("info",'Chức năng đang phát triển')} icon={<CheckCircleOutlined />} >Phê duyệt</Button>
                        }
                        {userInfo.user_permissions && userInfo.user_permissions.includes('is_personal_timesheet') &&
                        <Button ghost type='danger' className={'m-2'} onClick={()=>openNotificationWithIcon("info",'Chức năng đang phát triển')} icon={<CloseOutlined />}>Không duyệt</Button>
                        } */}
                    </div>
                    <div>
                    </div>
                </div>
            </div>
            <div className="row">
                <Spin spinning={loading}>
                    {data.length > 0 &&
                    <Table
                        dataSource={data}
                        columns={columns}
                        loading={loading}
                        bordered={true}
                        // scroll={{x:1200}}
                        className={'custom-table-hover'}
                        size={'small'}
                        rowKey="id"
                        onChange={handleChange}
                        // pagination={{
                        //     current: pager.current,
                        //     pageSize: pager.pageSize,
                        //     total: data.count,
                        //     showSizeChanger: true,
                        //     showQuickJumper: true,
                        //     pageSizeOptions: ['12', '15', '25', '50']
                        // }}
                        pagination={false}
                    />
                    }
                </Spin>
            </div>

        </>
    )
}